import { render, staticRenderFns } from "./widget-shop-article-detail-testing.vue?vue&type=template&id=230b6348"
import script from "./widget-shop-article-detail-testing.vue?vue&type=script&lang=ts"
export * from "./widget-shop-article-detail-testing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports